export default {
  greetings: '',
}
